import type { Table } from '@tanstack/react-table';
import { isNil } from 'es-toolkit';

import type { FilterType } from '../types/filter-meta';
import type { FilterValue } from '../types/filter-values';
import type { FilterableColumnData } from '../types/toolbar-slot-props';
import { getFilterLabel } from './get-filter-label';
import { getFilterOptions } from './get-filter-options';
import { getFilterRange } from './get-filter-range';

/**
 * Transforms TanStack Table columns into serializable FilterableColumnData.
 * Only includes columns that have filter metadata defined.
 */
export function getFilterableColumns<TData>(table: Table<TData>): FilterableColumnData[] {
  return table.getAllColumns().flatMap((column) => {
    const filterMeta = column.columnDef.meta?.filter;

    if (isNil(filterMeta)) {
      return [];
    }

    const label = getFilterLabel(column);
    const filterType = column.columnDef.filterFn as FilterType;

    return {
      id: column.id,
      label,
      filterType,
      filterMeta,
      options: getFilterOptions(column),
      range: getFilterRange(column),
      currentValue: column.getFilterValue() as FilterValue | undefined,
    };
  });
}
